import { useSyncExternalStore } from "react";

/**
 * ModalProvider captures `title` and `body` as two sibling nodes at
 * `openModal()` time, so they can't share React state (no common parent, no way
 * to re-render stored options). The map's visibility — toggled from the header,
 * applied in the body — therefore lives in a tiny external store created per
 * opened modal (same approach as the job picker's selection store).
 */
export interface MapVisibilityStore {
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => boolean;
  toggle: () => void;
}

export function createMapVisibility(initiallyVisible = true): MapVisibilityStore {
  let visible = initiallyVisible;
  const listeners = new Set<() => void>();

  return {
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    getSnapshot: () => visible,
    toggle: () => {
      visible = !visible;
      listeners.forEach((listener) => listener());
    },
  };
}

export const useMapVisible = (store: MapVisibilityStore) =>
  useSyncExternalStore(store.subscribe, store.getSnapshot);
